import { immer } from 'zustand/middleware/immer'

import { isNotNullish } from '~/utils/guards'

import { Slice } from '../store'

type State = {
    bookmarkedFolderIds: Record<string, true>
}

const initialState: State = {
    bookmarkedFolderIds: {},
}

type Actions = {
    actions: {
        setBookmarks: (folderIds: string[]) => void
        addBookmark: (folderId: string) => void
        removeBookmark: (folderId: string) => void
    }
}

export type SurgeryBookmarksSlice = {
    surgeryBookmarks: State & Actions
}

export const createSurgeryBookmarksSlice: Slice<SurgeryBookmarksSlice> = immer(set => ({
    surgeryBookmarks: {
        ...initialState,
        actions: {
            setBookmarks: folderIds => {
                set(state => {
                    state.surgeryBookmarks.bookmarkedFolderIds = Object.fromEntries(folderIds.map(id => [id, true]))
                })
            },
            addBookmark: folderId => {
                set(state => {
                    state.surgeryBookmarks.bookmarkedFolderIds[folderId] = true
                })
            },
            removeBookmark: folderId => {
                set(state => {
                    delete state.surgeryBookmarks.bookmarkedFolderIds[folderId]
                })
            },
        },
    },
}))

export function isBookmarked(folderId: string | null | undefined, bookmarkedFolderIds: Record<string, true>): boolean {
    return isNotNullish(folderId) && bookmarkedFolderIds[folderId] === true
}

export const selectIsBookmarked = (folderId: string | null | undefined) => (state: SurgeryBookmarksSlice) =>
    isBookmarked(folderId, state.surgeryBookmarks.bookmarkedFolderIds)
